<!-- 成长记录类型 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="archivesType" type="archivesType" clearable />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-成长记录类型',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '类型：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const archivesType = useQuery('archivesType', props.value);

    return {
      archivesType,
    };
  },
};
</script>
